__turbopack_context__.v({
  "colorPaletteSection": "lBZfra_colorPaletteSection",
  "colorSwatch": "lBZfra_colorSwatch",
  "colorSwatches": "lBZfra_colorSwatches",
  "fontName": "lBZfra_fontName",
  "imageGrid": "lBZfra_imageGrid",
  "knobsVideo": "lBZfra_knobsVideo",
  "knobsVideoContainer": "lBZfra_knobsVideoContainer",
  "logoConstructionSection": "lBZfra_logoConstructionSection",
  "logoRevealCaption": "lBZfra_logoRevealCaption",
  "logoRevealSection": "lBZfra_logoRevealSection",
  "logoWordmarkCaption": "lBZfra_logoWordmarkCaption",
  "logoWordmarkImage": "lBZfra_logoWordmarkImage",
  "logoWordmarkSection": "lBZfra_logoWordmarkSection",
  "logoWordmarkWrapper": "lBZfra_logoWordmarkWrapper",
  "metaBlock": "lBZfra_metaBlock",
  "metaGrid": "lBZfra_metaGrid",
  "metaLabel": "lBZfra_metaLabel",
  "metaLeft": "lBZfra_metaLeft",
  "metaOverview": "lBZfra_metaOverview",
  "metaRight": "lBZfra_metaRight",
  "metaSection": "lBZfra_metaSection",
  "metaText": "lBZfra_metaText",
  "metaTools": "lBZfra_metaTools",
  "meterSection": "lBZfra_meterSection",
  "meterVideo": "lBZfra_meterVideo",
  "meterVideoWrapper": "lBZfra_meterVideoWrapper",
  "ogImage": "lBZfra_ogImage",
  "ogImageCaption": "lBZfra_ogImageCaption",
  "ogImageSection": "lBZfra_ogImageSection",
  "ogImageWrapper": "lBZfra_ogImageWrapper",
  "page": "lBZfra_page",
  "problemMindmap": "lBZfra_problemMindmap",
  "storySection": "lBZfra_storySection",
  "storySectionBeforeVuMeter": "lBZfra_storySectionBeforeVuMeter",
  "swatchColor": "lBZfra_swatchColor",
  "swatchDescription": "lBZfra_swatchDescription",
  "swatchHex": "lBZfra_swatchHex",
  "swatchInfo": "lBZfra_swatchInfo",
  "swatchName": "lBZfra_swatchName",
  "swatchPureWhite": "lBZfra_swatchPureWhite",
  "swatchSignaturePink": "lBZfra_swatchSignaturePink",
  "swatchStudioDark": "lBZfra_swatchStudioDark",
  "typeBody": "lBZfra_typeBody",
  "typeCaption": "lBZfra_typeCaption",
  "typeDisplay": "lBZfra_typeDisplay",
  "typeHeadline": "lBZfra_typeHeadline",
  "typeLabel": "lBZfra_typeLabel",
  "typeRow": "lBZfra_typeRow",
  "typeSample": "lBZfra_typeSample",
  "typeSampleGeist": "lBZfra_typeSampleGeist",
  "typeTitle": "lBZfra_typeTitle",
  "typographySection": "lBZfra_typographySection",
  "typographySectionDivider": "lBZfra_typographySectionDivider",
  "typographyShowcase": "lBZfra_typographyShowcase",
  "videoCaption": "lBZfra_videoCaption",
  "videoContainer": "lBZfra_videoContainer",
  "vuMeterSection": "lBZfra_vuMeterSection",
  "webPresenceGrid": "lBZfra_webPresenceGrid",
});
